import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import CategoryPage from "@/pages/CategoryPage";
import Admin from "@/pages/Admin";
import { PrivacyPage, CookiePolicyPage } from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppBadge from "@/components/WhatsAppBadge";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/prodotti" element={<Products />} />
        <Route path="/prodotti/:slug" element={<CategoryPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      </Routes>
      {!isAdmin && <WhatsAppBadge />}
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
